import { render, staticRenderFns } from "./TestTubeInfo.vue?vue&type=template&id=6e870944&"
import script from "./TestTubeInfo.vue?vue&type=script&lang=js&"
export * from "./TestTubeInfo.vue?vue&type=script&lang=js&"
import style0 from "./TestTubeInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VListItem,VListItemContent,VListItemTitle})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e870944')) {
      api.createRecord('6e870944', component.options)
    } else {
      api.reload('6e870944', component.options)
    }
    module.hot.accept("./TestTubeInfo.vue?vue&type=template&id=6e870944&", function () {
      api.rerender('6e870944', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/VisitorScanPage/components/TestTubeInfo.vue"
export default component.exports